import request from '@/utils/request';


// 级联选择参数
export function getCityData(data) {
    return request({
        url: "/power-generation/region",
        method: "get",
        data,
    });
}

// 获取主数据
export function getSelectData(params) {
  return request({
      url: `/meta/main/${params.valueKey}`,
      method: "get",
      params,
  });
}

// 查询组件列表
export function getComponentList(params) {
  return request({
      url: "/component-config/list",
      method: "get",
      params,
  });
}

// 生成分析报告
export function generateReport(data) {
  return request({
      url: "/device/result",
      method: "post",
      data,
  });
}
// 生成PDF报告
export function generatePdfReport(data) {
  return request({
      url: "/report/pdf",
      method: "post",
      data,
  });
}

// 生成对比报告
export function generateCompareReport(data) {
  const token = localStorage.getItem("token");
  return request({
    url: "/product/result",
    method: "post",
    data,
    headers: {
      token,
      Authorization: `Bearer ${token}`,
    },
  });
}

/**
 * 计算容配比
 * @param {*} data
 * @returns {*}
 */
export function calCapacityRatio (data) {
  return request({
    url: '/device/getIrradiance',
    method: 'post',
    data
  })
}